import React from 'react'

const ReportsandAnalytics = () => {
  return (
    <header className='headerEditor'><h2>ReportsandAnalytics</h2></header>
  )
}

export default ReportsandAnalytics